import React from 'react';
import Header from "../../components/header";
import Footer from "../../components/footer";
import { connect } from "react-redux";
import RequestCharts from './requestCharts'



class AdminHome extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }



    render() {
        return (
            <React.Fragment>
                <Header status={"afterLogin"} routes={[{ "name": "Home", "route": "/AdminHome", }]} />


                <div className="content">
                    <div className="contentSection" id="content">
                        <div className="container-fluid">

                            <div className="bodyContent">

                                <RequestCharts />

                            </div>
                        </div>
                    </div></div>


                {/* Add Employee */}


                <Footer />

            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
     message: state.commonReducer.message,
    loginDetails: state.commonReducer.loginDetails,
});

// const mapDispatchToProps = dispatch => ({
//     getEmployeList: token => dispatch(getEmployeList(token)),
//     addEmploye: (Payload, token) => dispatch(addEmploye(Payload, token)),

// });

export default connect(
    mapStateToProps,
    null
)(AdminHome);

